'use strict';

var Promise = global.Promise || require('promise-polyfill');

module.exports = Promise;



//////////////////
// WEBPACK FOOTER
// ./~/braintree-web-drop-in/~/braintree-web/lib/promise.js
// module id = 30
// module chunks = 0